import {
  Constants,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export function getThemeSelectorWidgetConfig(): WorkflowWidgetConfig {
  const themeSelectorWidget: WorkflowWidgetConfig = {
    widgetTypeConfig: 'new',
    uniqueId: WidgetNames.THEME_SELECTOR,
    name: WidgetNames.THEME_SELECTOR,
    widgetConfiguration: {
      isRemovable: true,
      widgetDisplayName: WidgetTitles.THEME_SELECTOR,
      widgetConfigDisplayName: WidgetTitles.THEME_SELECTOR,
      attributes: {
        css_config: Constants.defaultBaseCssConfig,
        widgetProperties: {
          textContent: 'Change theme',
          toggleDefaultState: false,
          toggleOffTheme: 'default',
          toggleOnTheme: 'default',
          icon: '',
        },
        elementsConfig: [],
      },
    },
    widgetIconPath: 'toggle',
  };
  return themeSelectorWidget;
}
